import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '@infra/auth/auth.service';
import { ThemeService } from '@infra/theme/theme.service';
import { modal } from '@shared/alerts/modal/modal.alert';

@Injectable({
  providedIn: 'root',
})
export class PrimeiroAcessoGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private themeService: ThemeService,
  ) {}

  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.authService.credentials?.primeiroAcesso === 'S') {
      modal
        .fire({
          title: 'Primeiro acesso',
          text: 'Como é seu primeiro acesso, você precisa alterar sua senha.',
          icon: 'warning',
          confirmButtonText: 'Alterar senha',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          reverseButtons: true,
          allowOutsideClick: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.router.navigate(['/minha-conta']);
          } else {
            this.authService.credentials = null;
            this.router.navigate([this.themeService.identificador]);
          }
        });

      return false;
    }

    return true;
  }
}
